import store from '@/store/index';
import axios from 'axios';
import mime from 'mime-types';
import moment from 'moment';
import Vue from 'vue';

export const eventBus = new Vue({
  methods: {
    requestSuccess(name) {
      this.$emit('requestSuccess', name);
    }
  }
});

export const getComponent = (flowObject, componentName) => {
  let componentLocation = flowObject.components[componentName].location;
  return () => import(`@/components/${componentName}/${componentLocation}`);
};

export const getCurrentHostnameEndpoint = () => {
  if (process.env.NODE_ENV === 'development') {
    return `http://${window.location.hostname}:8080`;
  }

  if (process.env.NODE_ENV === 'staging') {
    return `https://${window.location.hostname}`;
  }

  return `https://${window.location.hostname}`;
};

export const getStorage = key => {
  return localStorage.getItem(key);
};

export const getSiteName = () => {
  return store.state.siteDetails.site_name;
};

export const getAddress = () => {
  return store.state.siteDetails.corp_uk_address;
};

export const setStorage = (key, value) => {
  return localStorage.setItem(key, value);
};

export const setCookie = (name, value, days) => {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

export const getCookie = name => {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const trackEvent = (eventName, callback) => {
  let expClient = window.expClient;
  if (!expClient) {
    document.addEventListener('csx_lib_loaded', () => {
      trackEvent(eventName, callback);
    });
  } else {
    expClient.trackEvent(eventName, callback);
  }
};

export const trackPageView = pageName => {
  return trackEvent(`zendesk_${pageName}_pageview`);
};

export const trackPageClick = clickName => {
  return trackEvent(`zendesk_${clickName}_click`);
};

export const orderCategories = (orderedArray, categoryObject) => {
  var orderedObject = {};
  for (var categoryId of orderedArray) {
    orderedObject[categoryId] = categoryObject[categoryId];
  }
  return orderedObject;
};

export const orderArticles = (orderedArticlesObject, articlesResults) => {
  var orderedArticles = {};
  for (var categoryId of Object.keys(orderedArticlesObject)) {
    orderedArticles[categoryId] = {};
    for (var articleId of orderedArticlesObject[categoryId]) {
      orderedArticles[categoryId][articleId] = articlesResults.find(articleEntry => {
        return articleEntry.data.id === Number(articleId);
      }).data;
    }
  }
  return orderedArticles;
};

export const deleteStorage = key => {
  return localStorage.removeItem(key);
};

export const getQueryVariable = function(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split(`&`);
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split(`=`);
    /* eslint-disable eqeqeq */
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};

export const getFlow = () => {
  if (getQueryVariable('flow')) {
    setStorage('flow', getQueryVariable('flow'));
  }

  if (getStorage('flow')) {
    return getStorage('flow');
  }
  // In the case they have no flow param or localstorage, we default
  setStorage('flow', 'zen');
  return 'zen';
};

export const setFlow = flowName => {
  return setStorage('flow', flowName);
};

export const getLanguage = fromLs => {
  let path = location.pathname.split('/');
  if (path[1]) {
    if (store.state.locales.includes(path[1])) {
      setStorage('lng', path[1]);
      return path[1];
    }
  }
  const preferred = getCookie('preferred_language');
  if (getCookie('preferred_language') && getQueryVariable('upl')) {
    const lng = preferred.toLowerCase() === 'en' ? 'en-us' : preferred.toLowerCase();
    return store.state.locales.includes(lng) ? lng : store.state.defaultLocale;
  }

  // @ts-ignore
  const browserLanguage = navigator.language || navigator.userLanguage;
  if (browserLanguage && getQueryVariable('udl')) {
    const lngCode = browserLanguage.toLowerCase().split('-')[0];
    if (store.state.locales.includes(lngCode)) {
      return lngCode;
    }
    return 'en-us';
  }

  if (getStorage('lng')) {
    return getStorage('lng');
  }
  return store.state.defaultLocale;
};

export const setLanguage = lng => {
  return localStorage.setItem('lng', lng);
};

// Get's Parameters from the URL and sets them in the localStorage
export const getParams = () => {
  // Set Site ID
  setCookie('siteDetails', JSON.stringify({ site_id: store.state.siteDetails.site_id }));

  // Set Helpcenter Type
  localStorage.setItem('helpcenter_type', store.state.siteDetails.helpcenter_type);
  setCookie('helpcenter_type', store.state.siteDetails.helpcenter_type, 100000);

  // Language
  setLanguage(getLanguage());

  // Setting Site ID
  setStorage('site_id', store.state.siteDetails.site_id);

  // Checking for Redirection
  var osRedirect = getQueryVariable('os_redirect');
  if (osRedirect) {
    redirectToZendesk();
  }
};

export const redirectToZendesk = () => {
  var siteName = store.state.siteDetails.site_name;
  var redirectLink = `https://${siteName.toLowerCase()}.zendesk.com/hc/${getLanguage()}${window.location.search}`;
  window.location.href = redirectLink;
};

// Get Category key name (translated)
export const getCategoryPageName = (catId, pagesObj) => {
  for (let key of Object.keys(pagesObj)) {
    if (pagesObj[key].meta) {
      if (pagesObj[key].meta.categoryId === String(catId)) {
        return key;
      }
    }
  }
};

export const getCategoryById = catId => {
  return store.state.categories[catId];
};

// This function will return a translated Path Name if you supply a route name and the router
export const getPathNameFromRouteName = (routeName, router) => {
  let mainRoute = router.options.routes.find(route => {
    return route.path === '/:locale';
  });
  for (let route of mainRoute.children) {
    if (routeName === route.name) {
      if (route.meta) {
        if (route.meta.categoryId) {
          return store.state.categories[route.meta.categoryId].title;
        }
      }
      return route.path;
    }
  }
  return false;
};

export const getCategoryIdByName = name => {
  return store.state.flowObject.pages[name].meta.categoryId;
};

export const getCategoryIdByArticleId = articleId => {
  for (let categoryId of Object.keys(store.state.articles)) {
    for (let article of store.state.articles[categoryId]) {
      if (Number(articleId) === Number(article.source_id) || Number(articleId) === Number(article.id)) {
        return categoryId;
      }
    }
  }
};

export const getPageHash = article => {
  const { id, title } = article;
  return `#${id}-${title.replace(/ /g, '-')}`;
};

export const getAllArticlesFromStore = () => {
  const categories = store.state.articles;
  const categoryIds = Object.keys(store.state.articles);
  const articles = [];

  categoryIds.forEach(categoryId => {
    categories[categoryId].forEach(article => {
      articles.push(article);
    });
  });
  return articles;
};

export const getSpecificArticleFromStore = articleId => {
  for (var categoryId of Object.keys(store.state.articles)) {
    for (var article of store.state.articles[categoryId]) {
      if (article.source_id === Number(articleId) || article.id === Number(articleId)) {
        return article;
      }
    }
  }
};

export const getLocalPhoneNumberByCountry = () => {
  const euCountries = [
    'AD',
    'AT',
    'EE',
    'DE',
    'GR',
    'IE',
    'LU',
    'MT',
    'MC',
    'ME',
    'PT',
    'SM',
    'SK',
    'SI',
    'GB',
    'IS',
    'BG',
    'AL',
    'BY',
    'BA',
    'HR',
    'CY',
    'CZ',
    'FO',
    'GI',
    'HU',
    'IM',
    'RS',
    'LV',
    'LI',
    'LT',
    'MK',
    'MD',
    'PL',
    'RO',
    'RU',
    'CH',
    'UA',
    'VA'
  ].map(c => c.toLowerCase());

  let localNumber;
  let storedCountryCode = localStorage.getItem('country_code');
  // console.log(`storedCountryCode is... ${storedCountryCode}`);

  // define strings to check for
  let tollFreeString = store.state.siteDetails.corp_info[`${storedCountryCode}_toll_free_number`];
  let paidPhoneString = store.state.siteDetails.corp_info[`${storedCountryCode}_phone_number`];

  if (tollFreeString) {
    // if there's a 'toll-free' number from corp,...

    // display 'toll-free number' for 'us', 'ca' & 'it'
    if (storedCountryCode === 'us' || storedCountryCode === 'ca' || storedCountryCode === 'it') {

      localNumber = store.state.siteDetails.corp_info[`${storedCountryCode}_toll_free_number`];
      localStorage.setItem('local_number', localNumber);
      return localNumber;
    }
  } else if (paidPhoneString) {
    // else if there's a regular (paid) number from corp,...

    // display 'uk toll-free number' for 'ru'
    if (storedCountryCode === 'ru') {
      localNumber = store.state.siteDetails.corp_info.uk_toll_free_number;
      localStorage.setItem('local_number', localNumber);
      return localNumber;

      // display 'local number' for all others
    } else {
      localNumber = store.state.siteDetails.corp_info[`${storedCountryCode}_phone_number`];
      localStorage.setItem('local_number', localNumber);
      return localNumber;
    }
  } else {
    // if there's neither or a mis-match.

    // display 'uk toll-free number' for 'uk'... mapped to 'gb'
    if (storedCountryCode === 'gb' || storedCountryCode === 'es') {
      localNumber = store.state.siteDetails.corp_info.uk_toll_free_number;
      localStorage.setItem('local_number', localNumber);
      return localNumber;

      // display 'es' after mapping to 'gb'
    } else if (euCountries.find(c => c === storedCountryCode)) {
      localNumber = store.state.siteDetails.corp_info.uk_toll_free_number;
      localStorage.setItem('local_number', localNumber);
      return localNumber;
    } else {
      localNumber = store.state.siteDetails.corp_info.us_toll_free_number;
      localStorage.setItem('local_number', localNumber);
      return localNumber;
    }
  }
};

export const replacePlaceholders = content => {
  const buildPromoDate = () => {
    const getPromotionStartDate = () => {
      const currentMonth = moment().format('MMMM');
      const currentYear = moment().year();

      const startDates = {
        January: [currentYear, 0, 1],
        February: [currentYear, 0, 1],
        March: [currentYear, 0, 1],
        April: [currentYear, 3, 1],
        May: [currentYear, 3, 1],
        June: [currentYear, 3, 1],
        July: [currentYear, 6, 1],
        August: [currentYear, 6, 1],
        September: [currentYear, 6, 1],
        October: [currentYear, 9, 1],
        November: [currentYear, 9, 1],
        December: [currentYear, 9, 1]
      };

      return moment(startDates[currentMonth]);
    };

    const promotionStartDate = getPromotionStartDate();
    return {
      startDate: promotionStartDate.format('MMMM, DD YYYY'),
      endDate: promotionStartDate.add(2, 'month').endOf('month').format('MMMM, DD YYYY')
    };
  };

  let parsedContent = content;
  const siteName = capitalize(store.state.siteDetails.site_name);

  const dateStore = buildPromoDate();
  const promotionStartDate = dateStore.startDate;
  const promotionEndDate = dateStore.endDate;

  const cancelArticleUrl = `article#${store.state.flowObject.variables.popularQuestions[1]}`;

  let getStoredLocalNumber = localStorage.getItem('local_number');
  const displayPrimaryNumber = getStoredLocalNumber;

  parsedContent = parsedContent.replace(new RegExp('__locale__', 'g'), getLanguage());
  parsedContent = parsedContent.replace(new RegExp('__site_name__', 'g'), siteName);
  parsedContent = parsedContent.replace(new RegExp('__nama_tapak__', 'g'), siteName);
  parsedContent = parsedContent.replace(new RegExp('__Site_name__', 'g'), siteName);
  parsedContent = parsedContent.replace(new RegExp('__site_name __ ', 'g'), siteName);
  parsedContent = parsedContent.replace(new RegExp('__domain_name__', 'g'), store.state.siteDetails.domain_name);
  parsedContent = parsedContent.replace(
    new RegExp('__international_phone_number__', 'g'),
    getLocalPhoneNumberByCountry()
  );

  parsedContent = parsedContent.replace(
    new RegExp('__local_phone_number__', 'g'),
    store.state.siteDetails.support_number_us_canada
  );
  // parsedContent = parsedContent.replace(
  //   new RegExp('__support_number_uk_intl__', 'g'),
  //   store.state.siteDetails.support_number_uk_intl
  // );

  parsedContent = parsedContent.replace(new RegExp('__primary_number__', 'g'), getLocalPhoneNumberByCountry);
  parsedContent = parsedContent.replace(
    new RegExp('__secondary_number__', 'g'),
    store.state.siteDetails.support_number_us_canada
  );

  parsedContent = parsedContent.replace(new RegExp('__corp_name__', 'g'), store.state.siteDetails.corp_name);
  parsedContent = parsedContent.replace(
    new RegExp('__corp_uk_address__', 'g'),
    store.state.siteDetails.corp_uk_address
  );
  parsedContent = parsedContent.replace(
    new RegExp('__corp_us_address__', 'g'),
    store.state.siteDetails.corp_us_address
  );

  parsedContent = parsedContent.replace(new RegExp('__promotion_start_date__', 'g'), promotionStartDate);
  parsedContent = parsedContent.replace(new RegExp('__promotion_end_date__', 'g'), promotionEndDate);

  parsedContent = parsedContent.replace(new RegExp('__cancel_article_url__', 'g'), cancelArticleUrl);

  return parsedContent;
};

export const parseCategoryPlaceholders = categories => {
  for (let i = 0; i < Object.keys(categories).length; i++) {
    categories[Object.keys(categories)[i]].title = replacePlaceholders(categories[Object.keys(categories)[i]].title);
    categories[Object.keys(categories)[i]].body = replacePlaceholders(categories[Object.keys(categories)[i]].body);
  }
  return categories;
};

export const parseArticlePlaceholders = articles => {
  for (let i = 0; i < Object.keys(articles).length; i++) {
    for (let j = 0; j < articles[Object.keys(articles)[i]].length; j++) {
      articles[Object.keys(articles)[i]][j].title = replacePlaceholders(articles[Object.keys(articles)[i]][j].title);
      articles[Object.keys(articles)[i]][j].body = replacePlaceholders(articles[Object.keys(articles)[i]][j].body);
    }
  }
};

export const validateRequest = (email, subject, description) => {
  let fields = [];
  if (!email) {
    fields.push('email');
  }
  if (!subject) {
    fields.push('subject');
  }
  if (!description) {
    fields.push('description');
  }
  if (fields.length > 0) {
    return { status: false, data: { message: 'missing fields', fields } };
  }
  const emailReg = new RegExp(
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
  );
  if (!emailReg.test(email)) {
    return { status: false, data: 'invalid email address' };
  }
  return { status: true };
};

export const handleRequestSubmit = (email, subject, description, article) => {
  let validity = validateRequest(email, subject, description);
  if (!validity.status) {
    return Promise.reject(validity.data);
  }
  let siteName = store.state.siteDetails.site_name;
  let domainName = store.state.siteDetails.domain_name;
  siteName = siteName[0].toUpperCase() + siteName.slice(1);
  let payload = {
    ticket: {
      comment: {
        uploads: []
      }
    }
  };
  payload.response = window.grecaptcha.getResponse();
  payload.ticket.email = email;
  payload.ticket.recipient = `support@${domainName}`;
  payload.ticket.subject = subject;
  payload.ticket.description = description;
  payload.helpcenter_type = store.state.siteDetails.helpcenter_type;
  payload.zendesk_api_url = store.state.siteDetails.zendesk_api_url;
  payload.ticket.custom_fields = [
    {
      id: 360017517292,
      value: siteName
    },
    {
      id: 360032022492,
      value: domainName
    }
  ];
  if (article) {
    payload.ticket.tags = [`articleid-${article}`];
  }

  var files = document.getElementById('files-list').children;
  for (let i = 0; i < files.length; i++) {
    if (files[i].dataset.status === 'pending') {
      return Promise.reject(new Error('file upload still in progress'));
    } else if (files[i].dataset.status === 'complete') {
      payload.ticket.comment.uploads.push(files[i].dataset.token);
    }
  }

  return axios.post(process.env.CSBP_URL + '/process/request_base', payload);
};

export const getHashValue = key => {
  var matches = location.hash.match(new RegExp(key + '=([^&]*)'));
  return matches ? matches[1] : null;
};

export const searchLocalArticles = queries => {
  const articles = getAllArticlesFromStore();

  return articles.filter(article => {
    const { title } = article;
    return queries.every(query => query.test(title));
  });
};

export const formatArticleTitles = (articles, query) => {
  const expressions = query.trim().split(' ');

  return articles.map(article => {
    const titleWords = article.title.split(' ');

    const newTitle = formatWords(expressions, titleWords);

    return {
      ...article,
      htmlTitle: newTitle
    };
  });
};

export const formatWords = (expressions, words) => {
  return words
    .map(word => {
      if (expressions.includes(word.toLowerCase())) {
        return `<strong>${word}</strong>`;
      }

      return expressions.reduce((curr, next) => {
        const re = new RegExp(next, 'i');
        const match = word.match(re);
        if (match) {
          return word.replace(re, `<strong>${match[0]}</strong>`);
        }

        return curr;
      }, word);
    })
    .join(' ');
};

export const getMatchingSnippet = (queries, body) => {
  const content = body.replace(/(<([^>]+)>)/gi, '').split('\n');
  const matching = content.find(sentence => {
    return queries.every(query => sentence.toLowerCase().includes(query.toLowerCase()));
  });

  if (matching) {
    const words = matching.split(' ');
    return formatWords(queries, words);
  }
  return content[0];
};

export const searchZendeskAPI = async query => {
  const siteName = getSiteName().toLowerCase();
  const queryString = query.toLowerCase().includes(siteName) ? query.replace(siteName, '__sitename__') : query;
  const zendeskApiUrl = store.state.siteDetails.zendesk_api_url;
  const request = await axios.get(
    `${zendeskApiUrl}/api/v2/help_center/articles/search.json?query=${queryString}&locale=${getLanguage()}`
  );

  const queries = queryString.split(' ');

  return request.data.results.map(result => {
    const article = getSpecificArticleFromStore(result.id);
    const title = formatWords(queries, article.title.split(' '));
    const actualBody = getSpecificArticleFromStore(article.id).body;
    const snippet = getMatchingSnippet(queries, actualBody);
    const catId = getCategoryIdByArticleId(result.id);
    const { title: categoryTitle } = getCategoryById(catId);

    return {
      ...article,
      formattedTitle: title,
      snippet: snippet.substring(0, 119),
      categoryId: catId,
      category: categoryTitle
    };
  });
};

export const uploadFile = file => {
  let zendeskApiUrl = store.state.siteDetails.zendesk_api_url;
  let options = {
    url: `${zendeskApiUrl}/api/v2/uploads.json?filename=${file.name}`,
    method: 'POST',
    data: file,
    headers: {
      'Content-Type': mime.lookup(file.name)
    }
  };
  return axios(options);
};

export const checkUserAuth = () => {
  let data = getCookie('csx_trk_data') || window.localStorage.getItem('csx_trk_data');

  try {
    const parsedData = JSON.parse(data);
    if (parsedData.is_logged_in) {
      return true;
    }
    return false;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const arrayMove = function(array, from, to) {
  array.splice(to, 0, array.splice(from, 1)[0]);
};

/**
 * Function to locate an element within the children and further descendants
 * of an HTML Element.
 *
 * Checks if element passed is equal to the target
 * If not, the function checks if the element has children and
 * loops over the children and performs this check again
 * Until an element is reached that has no children
 *
 * @param {HTMLElement} element
 * @param {HTMLElement} target
 */
export const findElementInChildren = (element, target) => {
  if (element === target) {
    return true;
  }
  if (element.children) {
    return Array.from(element.children).find(child => findElementInChildren(child, target));
  }
  return false;
};

export const capitalize = text => {
  const nameCapitalized = text.charAt(0).toUpperCase() + text.slice(1);
  return nameCapitalized;
};

/**
 * TO BE REMOVED ASAP
 */
export const searchZendeskAPITemp = async query => {
  const siteName = getSiteName().toLowerCase();
  const queryString = query.toLowerCase().includes(siteName) ? query.replace(siteName, '__sitename__') : query;
  const zendeskApiUrl = store.state.siteDetails.zendesk_api_url;
  const request = await axios.get(`${zendeskApiUrl}/api/v2/help_center/articles/search.json?query='${queryString}'`);

  const queries = queryString.split(' ');

  return request.data.results.map(result => {
    const article = getSpecificArticleFromStore(result.id);
    const title = formatWords(queries, article.title.split(' '));
    const actualBody = getSpecificArticleFromStore(article.id).body;
    const snippet = getMatchingSnippet(queries, actualBody);
    const catId = getCategoryIdByArticleId(result.id);
    const { title: categoryTitle } = getCategoryById(catId);

    return {
      ...article,
      formattedTitle: title,
      snippet: snippet.substring(0, 119),
      categoryId: catId,
      category: categoryTitle
    };
  });
};

/**
 * Function to GET user's 2-digit country code from endpoint
 * Store it in localStorage
 */
export const getCountryCode = () => {
  let data;
  let countryCode = getStorage('country_code');
  if (countryCode !== null) {
    return;
  }
  return axios
    .get('https://api.blackpants.systems/process/get-currency_base')
    .then((response) => {
      data = response.data;
      countryCode = data.country_code.toLowerCase();
      setStorage('country_code', countryCode);
      // console.log(`Set countryCode is... ${countryCode}`);
    })
    .catch((error) => console.log(error));
};

// Country URLs
export const available_countries = [
  'se',
  'ch',
  'fi',
  'be',
  'no',
  'dk',
  'lu',
  'de',
  'fr',
  'ck',
  'pg',
  'ie',
  'cl',
  'at',
  'kw',
  'tt',
  'nl',
  'nz',
  'jp',
  'py',
  'it',
  'bh',
  'jo',
  'uy',
  'cy',
  'ae',
  'az',
  'pt',
  'gd',
  'bs',
  'bm',
  'cr',
  'hu',
  'co',
  'pr',
  'ca',
  'sg',
  'us',
  'ec',
  'sa',
  'lb',
  'hr',
  'za',
  'cz',
  'au',
  'is',
  'si',
  'lt',
  'tr',
  'es',
  'rs',
  'ee',
  'sk',
  'mx',
  'pl',
  'mo',
  'mn',
  'kh',
  'bn',
  'mm',
  'bt',
  'aw',
  'bo',
  'gy',
  'lv',
  'kz',
  'gb',
  'pe',
  'hk',
  'ni',
  'pa',
  'gr',
  'sv',
  'do',
  'ar',
  'br',
  'jm',
  'gt',
  'hn',
  'bg',
  'mu',
  'mt',
  'kr',
  'tw',
  'vn',
  'lk',
  'th',
  'kg',
  'in',
  'cn',
  'ke',
  'cw',
  'ph',
  'mv',
  'bd',
  'am',
  'rs'
];
export const high_priority_countries = ['gb', 'fr', 'it', 'es', 'jp', 'nl', 'be', 'au', 'us', 'ca'];
export const low_priority_countries = ['cn'];
// UK Nutra Sites
export const ukNutraSites = [
  'allcure.net',
  'basiccbdoil.com',
  'cbdalchemy.net',
  'cbdcomfort.net',
  'cbdelixire.net',
  'cbdformula.net',
  'cbdforte.net',
  'cbdgains.net',
  'cbdhealthformula.net',
  'cbdmedpro.net',
  'cbdoilcure.net',
  'cbdoilex.net',
  'cbdoilmed.net',
  'cbdoilpharm.net',
  'cbdpaincontrol.net',
  'cbdpanacea.net',
  'cbdpotency.net',
  'cbdprofit.net',
  'cbdroom.net',
  'cbdsalvation.net',
  'cbdstrength.net',
  'cbdway.net',
  'curativeoil.com',
  'extracbdoil.net',
  'fortecbdoil.com',
  'fortecbdoil.net',
  'greenlineaid.com',
  'healthcbddrops.com',
  'healthlineoil.com',
  'hempoiltherapy.net',
  'hempoiltreat.net',
  'hempremedy.net',
  'herbaloilpanacea.net',
  'herbcbdoil.net',
  'herbrelief.net',
  'legalcannabisoil.net',
  'looseyourpain.com',
  'medcbdoil.net',
  'naturaloilcare.com',
  'novacbdoil.net',
  'oilremedy.net',
  'panaceaoil.net',
  'panamericancbd.com',
  'plaincbdoil.net',
  'procbdoil.net',
  'purecbdcure.net',
  'salutarycbd.com',
  'sanitumpercbd.com',
  'sativacbdoil.net',
  'vitacbd.net',
  'aceketo.net',
  'anticarb.net',
  'carbfighter.net',
  'carbinhibitor.com',
  'doctorketo.net',
  'forceketo.com',
  'kethonest.com',
  'ketoaccel.net',
  'ketoactivator.net',
  'ketoagent.net',
  'ketoagile.net',
  'ketoattack.com',
  'ketobenefit.net',
  'ketobolism.net',
  'ketoboom.net',
  'ketocarbblock.com',
  'ketocarbblocker.net',
  'ketocarbkiller.com',
  'ketocatalyst.net',
  'ketocharge.net',
  'ketodriver.net',
  'ketoengine.net',
  'ketofatburn.net',
  'ketofatkiller.com',
  'ketofatloss.net',
  'ketofitline.net',
  'ketoflame.net',
  'ketoflash.net',
  'ketoform.net',
  'ketogain.net',
  'ketoharmony.net',
  'ketoimpulse.net',
  'ketoline.net',
  'ketomania.net',
  'ketonecue.com',
  'ketonefuel.net',
  'ketoneplus.net',
  'ketopharm.net',
  'ketopunch.net',
  'ketorun.net',
  'ketoshuttle.com',
  'ketoslimming.net',
  'ketospark.net',
  'ketospeedup.com',
  'ketostyle.net',
  'ketosupp.net',
  'ketosuppl.net',
  'neatketo.com',
  'stopcarbs.com',
  'superketo.net'
];
export const ukCreditSites = [
  'bathandbeautyshop.com',
  'bookwormbox.net',
  'boxofchox.com',
  'boxofsox.net',
  'chocochic.net',
  'chocoshock.net',
  'chocostock.com',
  'cleanhelpingbox.net',
  'fourpawsclub.net',
  'heelandfootcare.com',
  'heelandtoes.net',
  'itsybitsybox.net',
  'manicurebox.net',
  'masterbath.net',
  'monthlybookbox.net',
  'mybabybox.net',
  'nailcarebox.net',
  'nosh-up.net',
  'petdelivery.net',
  'readerbox.net',
  'soxcloset.net',
  'tailandpaws.net',
  'tidydwelling.net',
  'totshop.net',
  'treatandfun.com',
  'babyshowerbox.net',
  'barsandsweets.com',
  'bathdeco.net',
  'bestsox.net',
  'bookamonth.net',
  'bookwormies.net',
  'buddystaff.net',
  'chocoland.net',
  'chocowave.net',
  'easychores.net',
  'fancybath.net',
  'findyoursocks.net',
  'footiestaff.com',
  'handcarebox.com',
  'heelscare.com',
  'holdbook.net',
  'hugyourpet.net',
  'luxebath.net',
  'monthlyread.com',
  'myfirstbox.net',
  'nailartbox.net',
  'nailboutique.net',
  'perfectchores.net',
  'stylishsox.com',
  'tidyupandsmile.com'
];

// setup queryParams in LocalStorage
const displayQueryParam = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const zma = urlParams.get('zma');
  // short for cancel
  const can = urlParams.get('can');

  if (zma && zma === 'true_ma') {
    setStorage('zma', zma);
  }

  if (can && ['true_hcr', 'true_mar'].some(e => e === can)) {
    setStorage('can', can);
  }

  if (getStorage('zma')) {
    document.querySelector('body').classList.add('zma');
  }
};
displayQueryParam();

const getCountry = () => {
  let address = getAddress();

  let array_countries = [
    'United Kingdom',
    'UK',
    'Cyprus',
    'Slovakia',
    'Czech Republic',
    'CZ',
    'USA'
  ];

  return array_countries.find(item => address && address.indexOf(item) > 0);
};

// Replace MA/HC Specific "LOGIN" & "SUPPORT@" Content
export const replaceMaHcLoginSupportContent = (articleId) => {
  // select PRE then show/hide hc/ma only content
  const preElementsArray = Array.from(document.getElementsByTagName('pre'));
  if (!preElementsArray) {
    return;
  }
  const controlMarkersArray = [];
  const maMarkersArray = [];
  const sweepsControlMarkersArray = [];
  const sweepsUkMarkersArray = [];
  const sweepsCyMarkersArray = [];
  const sweepsCzMarkersArray = [];

  preElementsArray.filter(controlItem => {
    if (controlItem.innerHTML.indexOf('__start_control') != -1) {
      controlMarkersArray.push(controlItem);
    }
  });

  preElementsArray.filter(maItem => {
    if (maItem.innerHTML.indexOf('__start_ma') != -1) {
      maMarkersArray.push(maItem);
    }
  });

  preElementsArray.filter(controlItem => {
    if (controlItem.innerHTML.indexOf('__start_sweeps_control_only') != -1) {
      sweepsControlMarkersArray.push(controlItem);
    }
  });

  preElementsArray.filter(controlItem => {
    if (controlItem.innerHTML.indexOf('__start_sweeps_uk_only') != -1) {
      sweepsUkMarkersArray.push(controlItem);
    }
  });

  preElementsArray.filter(controlItem => {
    if (controlItem.innerHTML.indexOf('__start_sweeps_cy_only') != -1) {
      sweepsCyMarkersArray.push(controlItem);
    }
  });

  preElementsArray.filter(controlItem => {
    if (controlItem.innerHTML.indexOf('__start_sweeps_cz_only') != -1) {
      sweepsCzMarkersArray.push(controlItem);
    }
  });
  // for variation (with localStorage entry) hide _hc_ content
  if (getStorage('zma') === 'true_ma') {
    // if zma=true_ma - hide all 'Log In' text...
    if (controlMarkersArray) {
      removeMarkersByKey(controlMarkersArray, '__start_control_only__');
    }
  }
  // default
  if (!getStorage('zma')) {
    // on default (if no localStorage entry) hide ma-specific stuff
    if (maMarkersArray) {
      removeMarkersByKey(maMarkersArray, '__start_ma_only__');
    }
  }
  // Update promotional terms for UK companies (https://hyunainternational.atlassian.net/browse/MBS-4309)
  if (getCountry() === 'United Kingdom' || getCountry() === 'UK') {
    if (sweepsControlMarkersArray) {
      removeMarkersByKey(sweepsControlMarkersArray, '__start_sweeps_control_only__');
    }
    if (sweepsCyMarkersArray) {
      removeMarkersByKey(sweepsCyMarkersArray, '__start_sweeps_cy_only__');
    }
    if (sweepsCzMarkersArray) {
      removeMarkersByKey(sweepsCzMarkersArray, '__start_sweeps_cz_only__');
    }
  } else if (getCountry() === 'Cyprus') {
    if (sweepsControlMarkersArray) {
      removeMarkersByKey(sweepsControlMarkersArray, '__start_sweeps_control_only__');
    }
    if (sweepsUkMarkersArray) {
      removeMarkersByKey(sweepsUkMarkersArray, '__start_sweeps_uk_only__');
    }
    if (sweepsCzMarkersArray) {
      removeMarkersByKey(sweepsCzMarkersArray, '__start_sweeps_cz_only__');
    }
  } else if (getCountry() === 'Czech Republic' || getCountry() === 'CZ') {
    if (sweepsControlMarkersArray) {
      removeMarkersByKey(sweepsControlMarkersArray, '__start_sweeps_control_only__');
    }
    if (sweepsUkMarkersArray) {
      removeMarkersByKey(sweepsUkMarkersArray, '__start_sweeps_uk_only__');
    }
    if (sweepsCyMarkersArray) {
      removeMarkersByKey(sweepsCyMarkersArray, '__start_sweeps_cy_only__');
    }
  } else {
    if (sweepsUkMarkersArray) {
      removeMarkersByKey(sweepsUkMarkersArray, '__start_sweeps_uk_only__');
    }
    if (sweepsCyMarkersArray) {
      removeMarkersByKey(sweepsCyMarkersArray, '__start_sweeps_cy_only__');
    }
    if (sweepsCzMarkersArray) {
      removeMarkersByKey(sweepsCzMarkersArray, '__start_sweeps_cz_only__');
    }
  }
  // hide all 'pre' tags
  preElementsArray.forEach(preItem => {
    preItem.style.display = 'none';
  });
};

const removeMarkersByKey = (markersArray, key) => {
  markersArray.forEach(marker => {
    if (marker.innerHTML === key || marker.innerHTML === ` ${key} ` ||
      marker.innerHTML === ` ${key}` || marker.innerHTML === `${key} `) {
      marker.parentElement.removeChild(marker.nextElementSibling);
      marker.parentElement.removeChild(marker);
    }
  });
};
